/* eslint-disable react/jsx-fragments */
import {useQuery} from '@apollo/client';
import isUrl from 'core/libs/helpers/isUrl';
import notification from 'core/libs/helpers/notification';
import log from 'core/libs/logger';
import Link from 'modules/common/Link';
import LoadingIndicator from 'modules/common/LoadingIndicator';
import PropTypes from 'prop-types';
import React, {Fragment} from 'react';
import {FormattedDate, FormattedMessage} from 'react-intl';
import BOOTCAMP_EVENTS from '../../graphql/bootcampEvents.graphql';
import TRACK_EVENTS from '../../graphql/trackEvents.graphql';
import {mhBootcampEventsBox, noteline} from './style.scss';

const BootcampEvents = ({degreeId, degreeName, degreeSlug, partner}) => {
  const {data, loading, error} = useQuery(
    partner === 'BARMEJ' ? BOOTCAMP_EVENTS : TRACK_EVENTS,
    {
      variables: partner === 'BARMEJ' ? {degreeId} : {trackId: degreeId},
    },
  );
  if (loading) return <LoadingIndicator />;
  if (error) {
    const errorMessage = error.message;
    log('Error while track events fetching', {
      errorMessage,
      currentUrl: typeof window !== 'undefined' && window.location.href,
    });
    notification({message: errorMessage});
  }
  const items =
    partner === 'BARMEJ'
      ? data && data.degreeEvents
      : data && data.partnerTrackEvents;
  const isAndroidBootcamp = degreeSlug && degreeSlug.includes('android');
  return (
    <Fragment>
      {items && items.length > 0 && (
        <div className={mhBootcampEventsBox}>
          <h3 className="tr-ns tc tc-m blue mb3">
            <FormattedMessage
              id={partner === 'BARMEJ' ? 'bootcamp_events' : 'track_events'}
              values={{degreeName}}
            />
          </h3>
          <div className="overflow-x-auto">
            <table className="collapse ba b--near-white">
              <thead>
                <tr>
                  <th>
                    <FormattedMessage id="event_deadline" />
                  </th>
                  <th>
                    <FormattedMessage id="subject" />
                  </th>
                  <th>
                    <FormattedMessage id="project" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {items &&
                  items.map(({date, subject, project}, index) => {
                    const parsedSubject = subject && JSON.parse(subject);
                    const parsedProject = project && JSON.parse(project);
                    return (
                      <tr key={index}>
                        <td className="w-25">
                          <span className="blue mt3">
                            <FormattedDate
                              value={date}
                              year="numeric"
                              month="long"
                              day="2-digit"
                            />
                          </span>
                        </td>
                        <td className="w-25">
                          {parsedSubject &&
                            parsedSubject.map(({title, link}, subjectIndex) => {
                              const isExternalLink = isUrl(link);
                              return (
                                <Fragment key={subjectIndex}>
                                  -{' '}
                                  <Link
                                    className="lh-copy mt3 underline dim blue"
                                    to={!isExternalLink ? link : undefined}
                                    href={isExternalLink ? link : undefined}
                                    target={isExternalLink ? '_blank' : null}
                                    rel={
                                      isExternalLink
                                        ? 'noopener noreferrer'
                                        : null
                                    }
                                  >
                                    {title}
                                  </Link>
                                  <br />
                                </Fragment>
                              );
                            })}
                        </td>
                        <td className="w-25">
                          {parsedProject &&
                            parsedProject.map(({title, link}, projectIndex) => {
                              const isExternalLink = isUrl(link);
                              return (
                                <Fragment key={projectIndex}>
                                  -{' '}
                                  <Link
                                    className="lh-copy mt3 underline dim blue"
                                    to={!isExternalLink ? link : undefined}
                                    href={isExternalLink ? link : undefined}
                                    target={isExternalLink ? '_blank' : null}
                                    rel={
                                      isExternalLink
                                        ? 'noopener noreferrer'
                                        : null
                                    }
                                  >
                                    {title}
                                  </Link>
                                  <br />
                                </Fragment>
                              );
                            })}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          {isAndroidBootcamp && (
            <div className={`${noteline} tr-ns tc mt3`}>
              <p className="blue">
                <FormattedMessage id="note" />:
              </p>
              &nbsp;
              <p>
                <FormattedMessage id="check_apps" />
              </p>
              &nbsp;
              <a
                href="https://play.google.com/store/apps/developer?id=CODED"
                target="_blank"
                rel="noopener noreferrer"
                className="blue underline dim"
              >
                <FormattedMessage id="click_here" />
              </a>
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
};

BootcampEvents.propTypes = {
  degreeId: PropTypes.number.isRequired,
  degreeName: PropTypes.string.isRequired,
  degreeSlug: PropTypes.string.isRequired,
  partner: PropTypes.string.isRequired,
};

export default BootcampEvents;
